import { Button, Flex, Link } from "@chakra-ui/react";

export const Timeline = () => {

  return (
    <Flex flexDir="column" align="center" alignItems="center" justify="center" py="40px">
      <Flex textAlign="center" paddingX={"24px"} fontSize={"24px"}>Focus Pass staking & calendar has moved to:</Flex>

      <Link display={"grid"} href="https://truegems.io/staking"><Button marginTop={4} height={14}>truegems.io staking</Button></Link>
    </Flex>
  );
};
